/* Capabilities naming*/
const FLEXIBLE_ATTRIBUTES = "flexibleAttributes";
export const HELP_DOC_URL = "helpDocUrl";

//Extended functionality of Flexible attributes
export const SID_GUID_FLEXIBLE_ATTRIBUTES = "objectSidGuidAttributes";
//OpenID Connect functionality
export const OIDC = "oidc";
//User extended attributes
export const USER_EXTENDED_ATTRIBUTES = "userExtendedAttributes";
//User group attributes
export const USER_GROUP_ATTRIBUTES = "userGroupAttributes";
//Non LDAP Epic Username
export const NON_LDAP_EPIC_USERNAME = "nonLdapEpicUsername";
//SBA Workflow Mapping
export const SBA_WORKFLOW_MAPPING = "sbaWorkflowMapping";

/* Required Capabilities mapping*/
export const capabilitiesMap = {
  UserAttributes: [FLEXIBLE_ATTRIBUTES],
  SamlHelpUrl: [HELP_DOC_URL]
}